import { importLibrary, setOptions } from "@googlemaps/js-api-loader";

import { env } from "@/web/lib/env";

let placesLibraryReady: Promise<void> | null = null;

async function ensurePlacesLibrary(): Promise<void> {
  if (!placesLibraryReady) {
    setOptions({ key: env.VITE_GAPI_PLACES_KEY, v: "weekly" });
    placesLibraryReady = importLibrary("places").then(() => undefined);
  }
  await placesLibraryReady;
}

const PLACE_DETAIL_FIELDS: google.maps.places.PlaceFetchableField[] = [
  "id",
  "displayName",
  "addressComponents",
  "websiteURI",
  "primaryType",
  "primaryTypeDisplayName",
  "types",
  "photos",
];

/**
 * Loads full place details for a Places autocomplete prediction — always hits Google
 * (no app-side cache). Uses `toPlace()` + `fetchFields()` as in Google's autocomplete-data samples.
 */
export async function fetchPlaceDetailsFromPrediction(
  prediction: google.maps.places.PlacePrediction,
): Promise<google.maps.places.Place> {
  await ensurePlacesLibrary();
  const place = prediction.toPlace();
  const result = await place.fetchFields({ fields: [...PLACE_DETAIL_FIELDS] });
  const resolved = (result as { place?: google.maps.places.Place }).place ?? place;
  return resolved;
}

/** Loads place details by Places ID (e.g. confirm step after SMB row already has `googlePlaceId`). */
export async function fetchPlaceDetailsByPlaceId(
  placeId: string,
): Promise<google.maps.places.Place> {
  await ensurePlacesLibrary();
  const place = new google.maps.places.Place({ id: placeId });
  const result = await place.fetchFields({ fields: [...PLACE_DETAIL_FIELDS] });
  return (result as { place?: google.maps.places.Place }).place ?? place;
}
